<template>
  <div class="part4" :style="bg">
    <!--        <img class="bg" :src=bg alt="">-->
    <div class="contentWrap" v-if="active == 3 || active == 4">
      <div class="animate__animated animate__fadeIn">
        <img src="../assets/index/line.png" alt="" />
      </div>
      <div class="title1 animate__animated animate__fadeIn delay1">
        {{ three_title }}
      </div>
      <!--            <div class="title2 animate__animated animate__fadeIn delay2">以客户利益为核心 <br> 以服务至上为立企之本</div>-->
      <div class="title3 animate__animated animate__fadeIn delay3">
        <!-- 用阁韵100%努力 换客户100%满意 -->
        {{ three_desc }}
      </div>
      <div class="bottomWrap">
        <!-- @mouseover="change(1)" -->

        <div
          v-for="(item, index) in threelist"
          :key="index"
          @mouseover="handleMouse(index, item)"
          class="item animate__animated animate__fadeIn"
        >
          <div class="logo animate__animated animate__fadeIn">
            <img
              :src="threeactive == index ? item.hover_image : item.image"
              alt=""
            />
          </div>
          <div class="title animate__animated animate__fadeIn">
            {{ item.title }}
          </div>
        </div>
        <!-- <div
          class="item animate__animated animate__fadeIn delay2"
          @mouseover="change(2)"
        >
          <div class="logo animate__animated animate__fadeIn">
            <img :src="qgc" alt="" />
          </div>
          <div class="title animate__animated animate__fadeIn delay2">
            全过程服务
          </div>
        </div> -->
        <!-- <div
          class="item animate__animated animate__fadeIn delay3"
          @mouseover="change(3)"
        >
          <div class="logo animate__animated animate__fadeIn">
            <img :src="qth" alt="" />
          </div>
          <div class="title animate__animated animate__fadeIn delay3">
            全天候服务
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { index } from "../api/request";

export default {
  name: "Part2",
  props: {
    index: {
      default: 1,
    },
  },
  data() {
    return {
      animate: true,
      sort: 1,
      active: "",
      bg: {
        backgroundImage: "url(" + require("../assets/index/serBg1.png") + ")",
        backgroundSize: "cover",
        backgroundPosition: "center center",
        backgroundCover: "cover",
      },
      // qlyf: require("../assets/index/qlyf1.png"),
      // qgc: require("../assets/index/qgc.png"),
      // qth: require("../assets/index/qth.png"),

      three_title: "",
      three_desc: "",
      threelist: [],
      threeactive: 0,
    };
  },
  methods: {
    change(index) {
      // console.log(index);
      this.sort = index;
      this.animate = true;
      // switch (index) {
      //   case 1:
      //     this.qlyf = require("../assets/index/qlyf1.png");
      //     this.qgc = require("../assets/index/qgc.png");
      //     this.qth = require("../assets/index/qth.png");
      //     this.bg = {
      //       backgroundImage:
      //         "url(" + require("../assets/index/serBg1.png") + ")",
      //       backgroundSize: "cover",
      //       backgroundPosition: "center center",
      //       backgroundCover: "cover",
      //     };
      //     break;
      //   case 2:
      //     this.qlyf = require("../assets/index/qlyf.png");
      //     this.qgc = require("../assets/index/qgc1.png");
      //     this.qth = require("../assets/index/qth.png");
      //     this.bg = {
      //       backgroundImage:
      //         "url(" + require("../assets/index/serBg2.png") + ")",
      //       backgroundSize: "cover",
      //       backgroundPosition: "center center",
      //       backgroundCover: "cover",
      //     };

      //     break;
      //   case 3:
      //     this.qlyf = require("../assets/index/qlyf.png");
      //     this.qgc = require("../assets/index/qgc.png");
      //     this.qth = require("../assets/index/qth1.png");
      //     this.bg = {
      //       backgroundImage:
      //         "url(" + require("../assets/index/serBg3.png") + ")",
      //       backgroundSize: "cover",
      //       backgroundPosition: "center center",
      //       backgroundCover: "cover",
      //     };
      //     break;
      // }
    },

    handleMouse(index, item) {
      this.threeactive = index;
      // console.log(index);
      // console.log(item);
      this.bg = {
        backgroundImage: `url(${item.bg_image})`,
        backgroundSize: "cover",
        backgroundPosition: "center center",
        backgroundCover: "cover",
      };
    },
  },
  mounted() {
    index().then((res) => {
      if (res.data.code == 1) {
        // console.log(res.data.data);
        this.three_title = res.data.data.three_title;
        this.three_desc = res.data.data.three_desc;
        this.threelist = res.data.data.three;
      }
    });

    // var that = this
    // if( this.animate){
    //     setInterval(function () {
    //         that.animate = false
    //     },500)
    // }
  },
  watch: {
    index(val) {
      console.log(val);
      this.active = val;
    },
  },
};
</script>

<style scoped lang="less">
.part4 {
  font-family: 微软雅黑, MicrosoftYaHei;
  color: #ffffff;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
  .bg {
    position: absolute;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    // background-size: "cover";
    // background-position: "center center";
  }
  .contentWrap {
    text-align: left;
    padding: 204px 0 0 13%;
    .footer {
      width: 100%;
      height: 350px !important;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .title1 {
      margin-top: 44px;
      font-size: 42px;
    }
    .title2 {
      margin-top: 32px;
      font-size: 60px;
      font-weight: bold;
    }
    .title3 {
      margin-top: 32px;
      font-size: 24px;
    }
    .bottomWrap {
      margin-top: 92px;
      display: flex;
      align-items: center;
      .item {
        background-size: "cover";
        background-position: "center center";

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-right: 42px;
        width: 180px;
        .logo {
          width: 80px;
          height: 80px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .title {
          font-size: 24px;
          margin-top: 29px;
        }

        .line {
          width: 298px;
          height: 1px;
          background: #ffffff;
          border-radius: 10px;
          margin-top: 43px;
        }
      }
    }
  }
}
@media screen and (max-width: 450px) {
  .part4 {
    font-family: 微软雅黑, MicrosoftYaHei;
    color: #ffffff;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    position: relative;
    .bg {
      position: absolute;
      width: 100%;
      height: 100vh;
      top: 0;
      left: 0;
    }
    .contentWrap {
      text-align: left;
      padding: 204px 0 0 13%;
      .footer {
        width: 100%;
        height: 350px !important;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .title1 {
        margin-top: 44 * 4px;
        font-size: 42 * 2px;
      }
      .title2 {
        margin-top: 32 * 2px;
        font-size: 60 * 2px;
        font-weight: bold;
      }
      .title3 {
        margin-top: 32 * 2px;
        font-size: 24 * 2px;
      }
      .bottomWrap {
        margin-top: 92 * 2px;
        display: flex;
        align-items: center;
        .item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-right: 42 * 2px;
          width: 220 * 2px;
          .logo {
            width: 80 * 2px;
            height: 80 * 2px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .title {
            font-size: 24 * 2px;
            margin-top: 29 * 2px;
          }

          .line {
            width: 298 * 2px;
            height: 1px;
            background: #ffffff;
            border-radius: 10 * 2px;
            margin-top: 43 * 2px;
          }
        }
      }
    }
  }
}
</style>
